module.exports = __webpack_public_path__ + "assets/img/home-customer-choice-light.080c94b2.png";